module.exports = __webpack_public_path__ + "img/seatsavailicn.87116c82.svg";